export default class MailingAddress {
  constructor() {
    this.street_address = '';
    this.address2 = '';
    this.state = '';
    this.city = '';
    this.zipcode = '';
    this.active = '';
  }
}
